<script lang="ts">
    import { MultiSelect } from "carbon-components-svelte";
    import {deep_copy, diffArray, isBuiltin, newId} from './jmdb'
    import type { ReadyList, Named, GroupSchema } from "./jmdb";
    import stringify from 'fast-json-stable-stringify'

    import { TextInput } from "carbon-components-svelte";
    import { Button as CarbonButton, ButtonSet } from "carbon-components-svelte";
    import TrashCan32 from "carbon-icons-svelte/lib/TrashCan32";
    import Save32 from "carbon-icons-svelte/lib/Save32";


    export let elements: ReadyList<Named>
    export let selected : Named
    export let schema: GroupSchema<any, any>

    let selectedIds: string[] = ((selected as any)[schema.group_key] as number[]).map(v=>v.toString())
    let oldSelectedIds: string[] = deep_copy(selectedIds)
    let oldName = selected.name
    
    let ids_dirty = false
    $: ids_dirty = stringify(oldSelectedIds.map(v=>v).sort()) != stringify(selectedIds.map(v=>v).sort())
    let name_dirty = false
    $: name_dirty = oldName != selected.name

    let dirty = false
    $: dirty = ids_dirty || name_dirty
    let in_flight = false

    let built_in = false
    $: built_in = isBuiltin(selected.id)
    
    
    let after_changes = (res: Response) => {
        if (!res.ok) {
            res.text().then((txt) => {
                window.alert(txt)
            })
            in_flight = false
        } else {
            schema.group_store.invalidate()
            Promise.all([schema.group_store.fetch()]).then(() => {
                in_flight = false
            })
        }
    }

    function saveClicked() {
        let changeBundle: any = {
            name: selected.name,
        }
        // Always include job on new actors
        changeBundle.memberChanges = diffArray(oldSelectedIds.map(v=>Number(v)), selectedIds.map(v=>Number(v)), (v)=>v, false)
        fetch("/api/v1/"+schema.resource_path+"/"+selected.id, {
            'method': 'POST',
            'body': JSON.stringify(changeBundle)
        }).then(after_changes)
        in_flight = true
    }

    function deleteClicked(e: Event) {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete "+selected.name+"?")) {
            fetch("/api/v1/"+schema.resource_path+"/"+selected.id, {
                'method': 'DELETE',
                'body': JSON.stringify({})
            }).then(after_changes)
        }
    }

</script>
    <TextInput disabled={built_in} bind:value={selected.name} labelText="Name" placeholder="Enter group's display name"/>
    {#if elements.ready}
    <MultiSelect disabled={built_in}
        titleText="Members:"
        label={selectedIds.map(v => elements.data.find(ag => (ag.id.toString() == v)) || {'name': "Not found"}).map(ag=>ag.name).join(', ') || "No members"}
        items={elements.data.map(v => { return {id: v.id.toString(), val: v.id, text: v.name}})}
        bind:selectedIds={selectedIds}
        />
        

    {/if}

<ButtonSet stacked style="float: right;">
    <CarbonButton kind="primary" icon={Save32} disabled={!dirty || in_flight} on:click={saveClicked}>Save</CarbonButton>
    {#if selected.id != newId}
    <CarbonButton disabled={built_in} kind="danger-ghost" icon={TrashCan32} tooltipPosition="left" on:click={deleteClicked}>Delete</CarbonButton>
    {/if}
</ButtonSet>
    